import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from '../plugins/auth'
import { LinkTypeCode, LinkTitle } from '../dictionary/base'

const verifyLogin = true // 是否验证登录

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 路由匹配
// 注意：key为全小写
const routerMap = {
  login: LinkTypeCode.Login,
  'home/home': LinkTypeCode.Home,
  'mine/download': LinkTypeCode.DownLoad,
  'mine/mine': LinkTypeCode.Mine,
  'mine/mycoupon': LinkTypeCode.MyCoupon,
  'mine/msg': LinkTypeCode.Msg,
  'mine/mycollection': LinkTypeCode.MyCollection,
  'mine/myorder': LinkTypeCode.MyOrder,
  'mine/brokeragecity': LinkTypeCode.BrokerageCity,
  'mine/brokeragedetail': LinkTypeCode.BrokerageDetail,
  'mine/brokerageselectpay': LinkTypeCode.BrokerageSelectPay,
  'mine/brokerageconfirmorder': LinkTypeCode.BrokerageConfirmOrder,

  'mine/aftersale': LinkTypeCode.AfterSale,
  'mine/applyinvoice': LinkTypeCode.ApplyInvoice,
  'mine/addressshow': LinkTypeCode.AddressShow,
  'mine/storeinfo': LinkTypeCode.StoreInfo,
  'mine/myqualifications': LinkTypeCode.MyQualifications,
  'mine/orderdetails': LinkTypeCode.OrderDetails,
  'mine/orderrefunddetails': LinkTypeCode.OrderRefundDetails,
  'mine/feedback': LinkTypeCode.Feedback,
  'mine/disorderlyprice': LinkTypeCode.DisorderlyPrice,
  'mine/feedbackhistory': LinkTypeCode.FeedbackHistory,
  'mine/alwaysbuyslist': LinkTypeCode.AlwaysBuysList,
  'mine/vouchercenter': LinkTypeCode.VoucherCenter,
  'mine/helpcenter/helpcenter': LinkTypeCode.HelpCenter,
  'mine/newgoodscollect': LinkTypeCode.NewGoodsCollect,
  'mine/childaccount': LinkTypeCode.ChildAccount,
  'mine/addchildaccount': LinkTypeCode.AddChildAccount,
  'mine/mycontrolpin': LinkTypeCode.MyControlPin,
  'mine/addcontrolpinkind': LinkTypeCode.AddControlPinKind,
  'mine/interlocksettings': LinkTypeCode.InterlockSettings,
  'mine/bindgeneralstore': LinkTypeCode.BindGeneralStore,
  'mine/activityview': LinkTypeCode.ActivityView,
  'mine/activityseckillview': LinkTypeCode.ActivitySeckillView,
  'mine/activitygiftview': LinkTypeCode.ActivityGiftView,
  'mine/activitygoodsview': LinkTypeCode.ActivityGoodsView,

  'buycar/buycar': LinkTypeCode.BuyCar,
  'buycar/confirmorder': LinkTypeCode.ConfirmOrder,
  'buycar/paysuccess': LinkTypeCode.PaySuccess,
  'buycar/selectpay': LinkTypeCode.SelectPay,

  'product/productdetails': LinkTypeCode.Goods,
  'product/productlist': LinkTypeCode.ProductList,
  'product/arrivingsoonlist': LinkTypeCode.ArrivingSoonList,
  'product/newgoodslist': LinkTypeCode.NewGoodsList,
  'product/activityarealist': LinkTypeCode.ActivityAreaList,
  'product/brandlist': LinkTypeCode.Brand,
  'product/searchpage': LinkTypeCode.SearchPage,
  'product/storeygoodslist': LinkTypeCode.StoreyProductList,

  'activity/specialoffer': LinkTypeCode.SpecialOffer,
  'activity/activityproductlist': LinkTypeCode.ActivityProductList,

  'factory/factorylist': LinkTypeCode.FactoryList,
  'brand/brandlist': LinkTypeCode.BrandList,
  'factory/factorymorelist': LinkTypeCode.FactoryMoreList,
  'brand/brandmorelist': LinkTypeCode.BrandMoreList,
  'hotsale/hotsalelist': LinkTypeCode.HotSaleList
}
const routes = []
// 注册Components
const views = require.context('../views', true, /\.vue$/)
views.keys().forEach((k) => {
  const component = views(k).default
  // 已组建形式注册组件
  component.name && Vue.component(component.name, component)

  // 去除第一个‘/’和最后的‘.vue’
  let path = k.substring(k.indexOf('/') + 1, k.lastIndexOf('.vue'))
  // 根据配置替换path名称，如果没有配置，则保持默认配置（根据路径）
  path = routerMap[path.toLowerCase()] || path.toLowerCase()
  // 取最后一个‘/’到最后的数据(不包括‘/’)
  const name = path.substring(path.lastIndexOf('/') + 1)

  routes.push({
    path: '/' + path,
    name: name,
    component: component,
    meta: {
      title: name === '/' || name === '' ? '药约約 - 首页' : '药约約 - ' + LinkTitle[name],
      noNeedAuth: !!component.noNeedAuth // 添加该字段，表示进入这个路由是不需要登录的
    }
  })
  // console.log(routes)
  // console.log(LinkTitle[name])
})
const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes, // 在此处加入以下内容
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (verifyLogin) {
    const { Token, CustomerId, ContactsId } = auth.getLoginDatas()
    if (to.meta.title) {
      document.title = to.meta.title
    }
    // 判断该路由是否需要登录权限
    if (to.meta.noNeedAuth) {
      next()
    } else {
      // 通过vuex state获取当前的token是否存在
      if (Token && CustomerId && ContactsId) {
        next()
      } else {
        next({
          name: LinkTypeCode.Login,
          // 将跳转的路由path作为参数，登录成功后跳转到该路由
          query: { redirect: to.name }
        })
      }
    }
  } else {
    next()
  }
})
export default router
